import { DataBean } from "../DataBean";

export class CreditOpening extends DataBean {

  public async getCreditOpeningCatalogPorPropiedades( properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_getCreditOpeningCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getCreditOpeningToday( idAccount: number ): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_getCreditOpeningToday_Number",
      [idAccount]
    );
  }

  public async deleteCreditOpening(idCreditOpening: number): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "boolean_deleteCreditOpening_Number",
      [idCreditOpening]
    );
  }

  public async updateCreditOpening(bean: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.credit.bean.CreditOpening_updateCreditOpening_com.credit.bean.CreditOpening",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.credit.bean.CreditOpening",
        },
      ]
    );
  }
}
